import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = "token";
const TAB_KEY = "tabId";

function uuid4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
}

export function getTabId() {
  let id = sessionStorage.getItem(TAB_KEY);
  if (!id) {
    id = uuid4();
    sessionStorage.setItem(TAB_KEY, id);
  }
  return id;
}

export function saveToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem("tipo");
  localStorage.removeItem("usuarioId");
  localStorage.removeItem("cargo");
}

export function decodeToken() {
  const token = getToken();
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

export function isTokenValid() {
  const decoded = decodeToken();
  if (!decoded || !decoded.exp) return false;
  const now = Date.now() / 1000;
  return decoded.exp > now;
}

export function getAuthInfo() {
  const decoded = decodeToken();
  if (!decoded) return null;
  const { alias, exp } = decoded;
  return { alias, expiresAt: exp };
}

export function formatTime(tsSeconds) {
  if (!tsSeconds) return "";
  const date = new Date(tsSeconds * 1000);
  return date.toLocaleTimeString();
}

export function getSessionId() {
  const d = decodeToken();
  return d?.sessionId ?? null;
}